module.exports = __webpack_public_path__ + "img/francis_cabrel.745b7c39.jpg";